"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var rootElementId = "oui-viewstack-root";
function getViewstackRoot() {
    var viewstackRoot = document.getElementById(rootElementId);
    if (!viewstackRoot) {
        viewstackRoot = document.createElement("div");
        viewstackRoot.id = rootElementId;
        document.body.appendChild(viewstackRoot);
    }
    return viewstackRoot;
}
function doSupportCreatePortal() {
    return ReactDOM.createPortal !== undefined;
}
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.portalElement = null;
        return _this;
    }
    Portal.prototype.componentDidMount = function () {
        if (!doSupportCreatePortal()) {
            var viewstackRoot = getViewstackRoot();
            // generate a unique ID for the portal element
            Portal.instanceCounter += 1;
            var portalId = "oui-portal-instance-" + Portal.instanceCounter;
            var portalElement = document.getElementById(portalId);
            // add the div to the body if not there.
            if (!portalElement) {
                portalElement = document.createElement("div");
                portalElement.id = portalId;
                viewstackRoot.appendChild(portalElement);
            }
            this.portalElement = portalElement;
            this.componentDidUpdate();
        }
    };
    Portal.prototype.componentDidUpdate = function () {
        if (!doSupportCreatePortal()) {
            ReactDOM.render(React.createElement("div", null, this.props.children), this.portalElement);
        }
    };
    Portal.prototype.componentWillUnmount = function () {
        if (!doSupportCreatePortal()) {
            var viewstackRoot = getViewstackRoot();
            viewstackRoot.removeChild(this.portalElement);
        }
    };
    Portal.prototype.render = function () {
        if (doSupportCreatePortal()) {
            var viewstackRoot = getViewstackRoot();
            return ReactDOM.createPortal(this.props.children, viewstackRoot);
        }
        return React.createElement("div", null);
    };
    Portal.instanceCounter = 0;
    return Portal;
}(React.Component));
exports.default = Portal;
//# sourceMappingURL=Portal.js.map